import { flexWorkerService } from 'hq/services';
import { useMutation } from 'react-query';

export const useResendWorkerTemporaryPassword = () => {
  const mutationFn = async (workerEmail: string) =>
    await flexWorkerService.resendTemporaryPassword(workerEmail);

  return useMutation(mutationFn);
};
